import { createContext, useContext } from 'react';

// CurrentUser façade. AuthProvider injects either the Clerk-backed
// implementation (production) or the synthetic dev-user implementation
// (open-dev) so the rest of the app never branches on Clerk's
// presence and React's rules-of-hooks aren't violated.

export interface CurrentUserInfo {
  displayName: string;
  email?: string;
  signOut: () => void;
}

const DEV_FALLBACK: CurrentUserInfo = {
  displayName: 'dev-user',
  email: undefined,
  signOut: () => undefined,
};

const CurrentUserContext = createContext<CurrentUserInfo>(DEV_FALLBACK);

export const CurrentUserProvider = CurrentUserContext.Provider;

export function useCurrentUser(): CurrentUserInfo {
  return useContext(CurrentUserContext);
}
